import { render } from "./McrItemsTable.vue?vue&type=template&id=36bffb2a&scoped=true"
import script from "./McrItemsTable.vue?vue&type=script&lang=js"
export * from "./McrItemsTable.vue?vue&type=script&lang=js"

import "./McrItemsTable.vue?vue&type=style&index=0&id=36bffb2a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36bffb2a"]])

export default __exports__